"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromPromise = void 0;

var _PromiseObservable = require("./PromiseObservable");

var fromPromise = _PromiseObservable.PromiseObservable.create;
exports.fromPromise = fromPromise;